<template>
  <BreadCrumb class="hidden sm:block" />
  <StoryPage :entry="entry" :social-media-accounts="socialMediaAccounts" />
</template>

<script>
import gql from 'graphql-tag';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import { stripLocale } from '@/utils/i18n';
import StoryPage, { StoryPageFragment } from '@/components/stories/StoryPage';
import { SocialMediaAccountsFragment } from '@/components/layout/footer/SocialMediaAccounts';
import BreadCrumb from '@/components/layout/BreadCrumb';

export const StoryPageQuery = gql`
  query StoryPageQuery($site: String!, $uri: String!) {
    entry(section: "story", site: [$site], uri: [$uri]) {
      ...EntryPageFragment
      ...StoryPageFragment
    }

    socialSet: globalSet(site: [$site], handle: "socialMediaAccounts") {
      ...SocialMediaAccountsFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }

  ${EntryPageFragment}
  ${SeomaticFragment}
  ${StoryPageFragment}
  ${SocialMediaAccountsFragment}
`;

export default defineNuxtComponent({
  name: 'StoryPageController',

  components: { StoryPage, BreadCrumb },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri };

    const {
      entry,
      seomatic,
      socialSet: { socialMediaAccounts },
    } = await $craftRequest(StoryPageQuery, variables);

    return { entry, seomatic, socialMediaAccounts };
  },

  data() {
    return { socialMediaAccounts: [] };
  },

  created() {
    useEntryPage(this.entry, this.seomatic, { content_category: 'stories' });
  },
});
</script>
